import React, { Component, Fragment } from 'react';
import Cta from './Cta';
import Portfolioblock from './Portfolioblock';

class Content extends Component {
    render() {
        return (
            <Fragment>
                <Portfolioblock/>
                <Cta/>
            </Fragment>
        );
    }
}

export default Content;